import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { User } from "@/types/user";
import { ContactSubject } from "@/components/views/BottomNavBar/Contact";

interface ContactFormPayload {
  email: User["email"];
  first_name: User["first_name"];
  last_name: User["last_name"];
  subject: ContactSubject;
  message: string;
}

export const useContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const submitContactForm = async (payload: ContactFormPayload) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosInstance.post(
        "/core/contact/send_email",
        payload,
      );

      if (response.status === 200) {
        setSuccess(true);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else {
        setError("An unknown error occurred");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    submitContactForm,
    loading,
    error,
    success,
  };
};
